// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TANZ0","col":"styles_col__EHwsf"};